const rootUrl =
  process.env.NODE_ENV === "production" ? "https://app.mynew.jobs/api" : "";

export default rootUrl;
